import { api } from '../configs/axiosConfigs';

export const getListSortPropertyJoinForListSort = async (listSortId) => {
  return api.get(`list-sorts/${listSortId}/lspj.json`);
};

